import { CommonService } from "./../../../services/common.service";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BaseComponent } from "../../base.component";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { FileuploadService } from "src/app/services/fileupload.service";
declare var $: any;

@Component({
  selector: "app-institutions-list",
  templateUrl: "./institutions-list.component.html",
  styleUrls: ["./institutions-list.component.css"],
})
export class InstitutionsListComponent extends BaseComponent implements OnInit {
  gridList: any = [];
  countyList: any = [];
  countyId: any = "";
  subCountyId: any = "";
  subCountyList: any = [];
  approveData: any;
  userDetails: any = "";
  qasoUploadFile: any[] = [];
  item: any;

  constructor(
    CommonService: CommonService,
    toastr: ToastrService,
    private route: Router
  ) {
    super(CommonService, toastr);
  }

  ngOnInit(): void {
    this.LoadGridList();
    // this.LoadCounties();
  }

  LoadGridList() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall("CallCenter/GetAllInstitutions", {
      TNT_PARENT_CODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.gridList = res?.data;
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      }
    );
  }
  viewDocument(obj: any) {
    this.viewRegistrationForm(obj);
    this.approveData = obj;
  }
  viewRegistrationForm(obj: any) {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantbyId", {
      TNT_CODE: obj?.TNT_CODE,
    }).subscribe(
      (res: any) => {
        this.userDetails = res;
        if (this.userDetails != "" && this.userDetails != null) {
          this.qasoUploadFile = this.userDetails?.MULTIPLE_FILE_UPLOADS_DTO;
        }
        this.item = obj;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
        document.getElementById("institutnDtlsId")?.click();
      }
    );
  }
  viewCQASODocument(obj: any, type: string) {
    const filePath = obj?.CQASO_INSPECTIONREPORT_UPLOAD;
    if (!filePath) {
      return this.toastr.info("Inspection report not uploaded");
    }

    const fileUrl = environment.videoUrl + filePath;

    if (type === "view") {
      // Open file in a new tab
      window.open(fileUrl, "_blank");
    } else {
      // window.open(environment.videoUrl + filePath);
      this.forceDownload(
        fileUrl,
        `CQASO_Inspection_Report_${this.approveData?.TNT_NAME}.pdf`
      );
    }
  }
  forceDownload(url: string, filename: string) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl); // clean up
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  }
  viewCBEDocument(obj: any, type: string) {
    const filePath = obj?.upload_1;

    if (!filePath) {
      return this.toastr.info("CEB report not uploaded");
    }

    const fileUrl = environment.videoUrl + filePath;

    if (type === "view") {
      // Open file in a new tab
      window.open(fileUrl, "_blank");
    } else {
      // window.open(environment.videoUrl + filePath);
      this.forceDownload(
        fileUrl,
        `CEB_Inspection_Report_${this.approveData?.TNT_NAME}.pdf`
      );
    }
  }
}
